// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
/** @ngInject */
export function Controller(
    $scope,
    Alert,
    DestructiveOperationModal,
    SaaspassConnectDevelopersService,
) {
    this.$onInit = () => {
    const companyId = this.companyId;
    const connectId = this.connectId;
    $scope.saaspassConnectKey=null;
    $scope.saaspassConnectSecret=null;
    $scope.selection = 'integration';
    $scope.showCredentialsDP = function(applicationId) {
        $scope.appCredUrl =  SaaspassConnectDevelopersService.saaspassConnectCredentialsUrl;
        $scope.appCredUrl =$scope.appCredUrl.replace(":companyId", companyId);
        $scope.appCredUrl = $scope.appCredUrl.replace(":connectId", connectId);
        $scope.showSaaspassConnectAppCredPanel = function(data) {
            $scope.selection = 'apikey';
            console.log(data);
            $scope.saaspassConnectKey = data.applicationKey;
            $scope.saaspassConnectSecret = data.applicationPassword;
            $scope.publicKey = data.saaspassConnectPublicKey;
        };
        DestructiveOperationModal({
            titleKey: 'company_application_overview.destructive_op.credentials_title',
            textKey: 'company_application_overview.destructive_op.credentials_message',
            http: {method: 'GET', url: $scope.appCredUrl}
        }).then((data) => {
            $scope.showSaaspassConnectAppCredPanel(data);
        });
    };
    
    $scope.changeSecret=function() {
        SaaspassConnectDevelopersService.saaspassConnectCredentials.updateSaaspassConnect({
            companyId : companyId,
            connectId:connectId
        },{}).$promise.then(function(data) {
            $scope.selection = 'apikey';
            console.log(data);
            $scope.saaspassConnectKey = data.applicationKey;
            $scope.saaspassConnectSecret = data.applicationPassword;
            Alert('success', 'saaspass_connect.update_credentials_success');
        });
    }
    
    $scope.saaspassConnectDevelopersIntegrationTemplateUrl = require('./integration.html');
    $scope.imageDownloadUrl = (density) => require(`../images/buttons/${density}/login_with-saaspass.png`);
    };
}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/developers/developers.controller.js